import SchoolSummaryExporter from './SchoolSummaryExporter';

export default SchoolSummaryExporter;
